module.exports = __webpack_public_path__ + "static/img/i1.ef88d48b.png";